if (
  typeof Object !== undefined
  && Object.prototype
  && !Object.prototype.toQueryString
) {
  Object.defineProperty(Object.prototype, 'toQueryString', {
    value(includeQuestionMark = true) {
      return `${includeQuestionMark ? '?' : ''}${Object.keys(this).map(key => key + '=' + this[key]).join('&')}`;
    }
  });
}